module.exports = __webpack_public_path__ + "img/desk3.27324c57.png";